import { LinkIcon, RefreshCcw } from 'lucide-react';
import { Badge, Button, cn, DatePickerPreset, DefaultTooltip, Separator } from 'twyne-new.ui';

const HeaderActions = ({ className, children }) => <>
  <div className={cn('justify-end items-center gap-4 flex', className)}>
    {children}
  </div>
</>

const HeaderSeparator = ({ className }) => <Separator orientation='vertical' className={cn('py-5', className)} />

const RunButton = ({ onClick, isLoading, disabled }) => <Button disabled={disabled} size='lg' variant='outline' color="success" onClick={onClick}>
  <RefreshCcw size='14' className={isLoading ? 'animate-spin' : ''} />
</Button>

const ConfigureButton = ({ onClick = () => { } }) => <Button size="lg" variant='outline' onClick={onClick}>Configure</Button>

const ReportDatePicker = ({ dates, onChange }) => <DatePickerPreset
  value={{ $gte: dates?.startDate, $lte: dates?.endDate }}
  onChange={({ $gte: startDate, $lte: endDate }) => onChange({ startDate, endDate })}
  numberOfMonths={2}
  trigger={<TriggerDatePicker values={dates} />}
  valueType='moment'
/>

const PermanentLinkButton = ({ onClick = () => { } }) => <DefaultTooltip content='Permanent Link'>
  <Button variant='outline' onClick={onClick}>
    <LinkIcon size='16' />
  </Button>
</DefaultTooltip>

const TriggerDatePicker = ({ values }) => <Badge
  size='lg'
  color='accent'
  variant='light'
  className='self-center twy-subtle-accent-hover transition-all'
>
  {[values?.startDate?.format('MMM DD, YYYY'), 'to', values?.endDate?.format('MMM DD, YYYY') || '-'].join(' ')}
</Badge>

export { HeaderActions, HeaderSeparator, RunButton, ConfigureButton, ReportDatePicker, PermanentLinkButton, TriggerDatePicker }
